/**
 * Stub for `@terra-money/terra.proto/jax/tx`.
 *
 * @terra-money/feather.js@1.2.1 ships `dist/core/jax/**`, which imports this
 * path, but declares `@terra-money/terra.proto: ^4.0.3` — and terra.proto
 * dropped its `jax/` directory in 4.0.5, so any fresh install resolves a
 * version where the module does not exist and webpack fails to build.
 *
 * This app never sends jax messages, so the stub only needs to satisfy the
 * bundler. It throws loudly if anything actually tries to use it.
 *
 * Proper fix if jax is ever needed: pin @terra-money/terra.proto to 4.0.4
 * (via package.json "overrides") and drop this alias from config-overrides.js.
 */
const unavailable = name => () => {
  throw new Error(
    `@terra-money/terra.proto/jax/tx is not available in the installed ` +
      `terra.proto (jax was removed in 4.0.5). Called: ${name}`,
  );
};

const msg = name => ({
  fromPartial: unavailable(`${name}.fromPartial`),
  fromJSON: unavailable(`${name}.fromJSON`),
  toJSON: unavailable(`${name}.toJSON`),
  encode: unavailable(`${name}.encode`),
  decode: unavailable(`${name}.decode`),
});

module.exports = {
  MsgExecuteContract: msg('MsgExecuteContract'),
  MsgExecuteContractResponse: msg('MsgExecuteContractResponse'),
  MsgStoreCode: msg('MsgStoreCode'),
  MsgStoreCodeResponse: msg('MsgStoreCodeResponse'),
};
